import React from "react";
import "./contactBanner.css"; // We'll create this CSS file

const Contact_banner = () => {
    return (
        <section className="Contact-banner">
            <div className="banner-image"></div>
            <div className="banner-content">

                <h1>About us</h1>
                <div className="breadcrumb">
                    <a href="/">Home</a>
                    <span>/</span>
                    <a href="/about">About</a>
                </div>
                {/* <p>
                    We are dedicated to providing exceptional travel experiences with comfort,
                    safety, and reliability at the core of everything we do.
                </p>
                <a href="#services" className="cta-button">
                    Explore Our Services
                </a> */}
            </div>
        </section>
    );
};

export default Contact_banner;